module.exports = __webpack_public_path__ + "static/media/12.6f4cec3e.jpeg";